import React, { ReactNode, useMemo } from 'react'
import { FlagProvider } from '@unleash/proxy-client-react'
import { unleashConfig } from '../services/unleash/config'
import { initializeUnleashSDK } from '../services/unleash/unleash.sdk'

/**
 * Same structure as gcms-admin UnleashProvider, but uses @unleash/proxy-client-react
 * because @pw-tech/unleash/react is ESM-only and breaks CRA webpack.
 */
export function UnleashProvider({ children }: { children: ReactNode }) {
  useMemo(() => {
    try {
      initializeUnleashSDK()
    } catch (error) {
      console.error('Failed to initialize Unleash SDK:', error)
    }
  }, [])

  return (
    <FlagProvider
      config={{
        ...unleashConfig,
        ...(unleashConfig.context ? { context: unleashConfig.context } : {}),
      }}
    >
      {children}
    </FlagProvider>
  )
}
